import styled from 'styled-components';
import Box from '@nubank/nuds-web/components/Box/Box';
import { nuDSColor } from '@nubank/nuds-web/styles/themeUtils';

import { backgroundImage } from '@nubank/www-latam-commons/components/Image/Image';

export const StyledBox = styled(Box)`
  background-size: cover;
  background-position: center;
  background-color: ${nuDSColor('primary')};

  ${backgroundImage({
    xs: 'girl-holding-card/girl-holding-card-landing@xs.jpg',
    md: 'girl-holding-card/girl-holding-card-landing@md.jpg',
    lg: 'girl-holding-card/girl-holding-card-landing@lg.jpg',
  })}
`;

StyledBox.displayName = 'StyledBox';
